import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState } from 'react';
import { createPortal } from 'react-dom';
import Modal from './index.js';
import { ModalTrigger } from './Modal.styles.js';

var _excluded = ["children", "hasMegaForm", "heading", "modalText", "showModal", "size", "noExit"];
var ModalWithState = function ModalWithState(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$hasMegaForm = _ref.hasMegaForm,
    hasMegaForm = _ref$hasMegaForm === void 0 ? false : _ref$hasMegaForm,
    _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? null : _ref$heading,
    _ref$modalText = _ref.modalText,
    modalText = _ref$modalText === void 0 ? '' : _ref$modalText,
    _ref$showModal = _ref.showModal,
    showModal = _ref$showModal === void 0 ? false : _ref$showModal,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'lg' : _ref$size,
    _ref$noExit = _ref.noExit,
    noExit = _ref$noExit === void 0 ? false : _ref$noExit,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(showModal),
    _useState2 = _slicedToArray(_useState, 2),
    modalShowing = _useState2[0],
    setModalShowing = _useState2[1];
  var modalPortal = null;
  if (modalShowing && typeof document !== 'undefined') {
    modalPortal = /*#__PURE__*/createPortal(/*#__PURE__*/React__default.createElement(Modal, _extends({
      isShowing: modalShowing,
      noExit: noExit,
      onClose: function onClose() {
        return setModalShowing(false);
      },
      size: size,
      hasMegaForm: hasMegaForm
    }, props), heading && /*#__PURE__*/React__default.createElement("h1", null, heading), children), document.body);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ModalTrigger, {
    role: "dialog",
    tabIndex: "0",
    className: "leshen-modal-trigger",
    onClick: function onClick() {
      return setModalShowing(true);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        setModalShowing(true);
      }
    }
  }, modalText), modalPortal);
};
var ModalWithState$1 = ModalWithState;

export { ModalWithState$1 as default };
//# sourceMappingURL=ModalWithState.js.map
